import { render, staticRenderFns } from "./header1.vue?vue&type=template&id=be429c68&scoped=true"
import script from "./header1.vue?vue&type=script&lang=js"
export * from "./header1.vue?vue&type=script&lang=js"
import style0 from "./header1.vue?vue&type=style&index=0&id=be429c68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be429c68",
  null
  
)

export default component.exports